"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
const google_1 = require("./google");
const image_server_1 = require("./image_server");
const MorowPlayer_1 = __importStar(require("./MorowPlayer"));
const CountrySelector_1 = __importDefault(require("./CountrySelector"));
let currentlyPlayingTrack;
let historyUrl;
let lastRefresh;
const refreshHistory = () => {
    console.debug("Refreshing playlist");
    if (!historyUrl)
        return;
    fetch(historyUrl).then((data) => {
        return data.json();
    }).then(history => {
        console.debug("History received: ");
        console.debug(history);
        const currentlyPlayingTrack = history[0];
        updateUI(history);
        console.debug(`Now is ${new Date()}`);
        console.debug(`Last refresh was at ${new Date(lastRefresh * 1000)}`);
        console.debug(`Track started to play at ${new Date(currentlyPlayingTrack.playedAt * 1000)}`);
        console.debug(`Track duration is ${(0, base_1.mmSS)(currentlyPlayingTrack.duration)} seconds`);
        const trackEndsAt = currentlyPlayingTrack.playedAt + currentlyPlayingTrack.duration;
        const nextRefreshAt = trackEndsAt + (0, base_1.getRandomIntInclusive)(2, 6);
        console.debug(`Next refresh should be between ${new Date((trackEndsAt + 2) * 1000)} and ${new Date((trackEndsAt + 6) * 1000)}`);
        let refreshTimeout = nextRefreshAt - getNowTimestamp();
        if (refreshTimeout < 0) {
            refreshTimeout = 30;
        }
        lastRefresh = getNowTimestamp();
        console.debug(`Next refresh in ${(0, base_1.mmSS)(refreshTimeout)}`);
        setTimeout(refreshHistory, refreshTimeout * 1000);
    });
};
const getNowTimestamp = () => {
    return Math.round(Date.now() / 1000);
};
const setPlayIcon = () => {
    var _a, _b;
    console.debug('setPlayIcon()');
    (_a = document.getElementById("play-stop-icon")) === null || _a === void 0 ? void 0 : _a.classList.add("fa-circle-play");
    (_b = document.getElementById("play-stop-icon")) === null || _b === void 0 ? void 0 : _b.classList.remove("fa-circle-notch", "fa-spin", "fa-circle-stop");
};
const setLoadingIcon = () => {
    var _a, _b;
    console.debug('setLoadingIcon()');
    (_a = document.getElementById("play-stop-icon")) === null || _a === void 0 ? void 0 : _a.classList.add("fa-circle-notch", "fa-spin");
    (_b = document.getElementById("play-stop-icon")) === null || _b === void 0 ? void 0 : _b.classList.remove("fa-circle-stop", "fa-circle-play");
};
const setStopIcon = () => {
    var _a, _b;
    console.debug('setStopIcon()');
    (_a = document.getElementById("play-stop-icon")) === null || _a === void 0 ? void 0 : _a.classList.add("fa-circle-stop");
    (_b = document.getElementById("play-stop-icon")) === null || _b === void 0 ? void 0 : _b.classList.remove("fa-circle-notch", "fa-spin", "fa-circle-play");
};
const updateUI = (history) => {
    var _a, _b, _c;
    const track = history.shift();
    if (!track) {
        return;
    }
    currentlyPlayingTrack = track;
    const nowPlayingTitle = document.querySelector('.nowplaying .title');
    if (nowPlayingTitle) {
        nowPlayingTitle.innerHTML = (_a = currentlyPlayingTrack.title) !== null && _a !== void 0 ? _a : "";
        nowPlayingTitle.dataset.query = currentlyPlayingTrack.title + " by " + currentlyPlayingTrack.artist;
    }
    const nowPlayingArtist = document.querySelector('.nowplaying .artist');
    if (nowPlayingArtist) {
        nowPlayingArtist.innerHTML = (_b = currentlyPlayingTrack.artist) !== null && _b !== void 0 ? _b : "";
        nowPlayingArtist.dataset.query = (_c = currentlyPlayingTrack.artist) !== null && _c !== void 0 ? _c : "";
    }
    const nowPlayingCover = document.querySelector('.nowplaying .cover');
    if (nowPlayingCover) {
        nowPlayingCover.src = "";
        nowPlayingCover.src = (0, image_server_1.coverThumbnail)(currentlyPlayingTrack.cover, 300);
    }
    history.forEach(function (historyTrack, index) {
        var _a, _b;
        const time = new Date(historyTrack.playedAt * 1000);
        const timeStr = ('0' + time.getHours()).slice(-2) + ":" + ('0' + time.getMinutes()).slice(-2);
        console.debug(timeStr);
        const historyEntry = document.querySelectorAll('.history .history-entry').item(index);
        if (!historyEntry) {
            return;
        }
        historyEntry.querySelector('.infos').dataset.query = historyTrack.title + " by " + historyTrack.artist;
        historyEntry.querySelector('.time').innerHTML = timeStr;
        historyEntry.querySelector('.time').dataset.time = time.toISOString();
        historyEntry.querySelector('.title').innerHTML = (_a = historyTrack.title) !== null && _a !== void 0 ? _a : "";
        historyEntry.querySelector('.artist').innerHTML = (_b = historyTrack.artist) !== null && _b !== void 0 ? _b : "";
    });
    (0, base_1.updateUTCToUserTZ)();
    (0, google_1.generateGoogleLinks)();
};
(() => {
    var _a;
    document.querySelectorAll(".dropdown-btn").forEach((element) => {
        const button = element;
        button.addEventListener("click", (event) => {
            const clickedButton = event.currentTarget;
            (0, base_1.openCloseDropdown)(clickedButton);
        });
    });
    // Close the dropdown menu if the user clicks outside of it
    window.addEventListener('click', (event) => {
        let target = event.target;
        if (target.classList.contains('dropdown-btn')) {
            return;
        }
        while ((target = target.parentElement) != null) {
            if (target.classList.contains('dropdown-btn')) {
                return;
            }
        }
        (0, base_1.closeAllDropdowns)();
    });
    const initialData = document.getElementById('history-data');
    if (!initialData) {
        console.error('No initial history data defined');
    }
    const audioElement = document.getElementById("morow-player");
    const morowPlayer = new MorowPlayer_1.default(audioElement);
    const countrySelector = new CountrySelector_1.default();
    (_a = document.getElementById("play-stop-button")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", () => {
        if (morowPlayer.isPlaying()) {
            morowPlayer.stop();
        }
        else {
            morowPlayer.play();
        }
    });
    document.querySelectorAll('.country-select').forEach((element) => {
        const entry = element;
        entry.addEventListener('click', (e) => {
            const target = e.currentTarget;
            if (!target.dataset.country) {
                return;
            }
            console.debug(`clicked country ${target.dataset.country}`);
            if (target.dataset.country === 'auto') {
                countrySelector.findBestCountry();
                return;
            }
            countrySelector.selectCountry(target.dataset.country);
        });
    });
    countrySelector.addEventListener('searching', () => {
        document.querySelectorAll('.stream-selector-icon').forEach((element) => {
            const icon = element;
            (0, base_1.hideElement)(icon, icon.dataset.country != 'spinner');
        });
    });
    countrySelector.addEventListener('changed', ((event) => {
        const countryCode = event.detail;
        console.debug(`country changed to ${countryCode}`);
        document.querySelectorAll('.stream-selector-icon').forEach((element) => {
            const icon = element;
            (0, base_1.hideElement)(icon, icon.dataset.country != countryCode);
        });
        morowPlayer.setUrl(MorowPlayer_1.streams[countryCode]);
    }));
    countrySelector.load();
    morowPlayer.addEventListener('loading', () => {
        setLoadingIcon();
    });
    morowPlayer.addEventListener('play', () => {
        setStopIcon();
    });
    morowPlayer.addEventListener('stop', () => {
        setPlayIcon();
    });
    if (initialData) {
        historyUrl = initialData.dataset.historyUrl;
        const historyString = initialData.dataset.history;
        if (historyString) {
            const history = JSON.parse(historyString);
            currentlyPlayingTrack = history[0];
            updateUI(history);
        }
        // calculate when to refresh
        lastRefresh = getNowTimestamp();
        // force refresh
        refreshHistory();
    }
    (0, google_1.generateGoogleLinks)();
    (0, base_1.updateUTCToUserTZ)();
})();
